<script lang="ts" type="module">
    export let desktop: string
    // export let tablet: string
    // export let tabletportrait: string
    export let mobile: string
    export let alt: string
</script>

<picture>
    <source media="(min-width: 530px)" srcset="{desktop}" />
    <!-- <source media="(min-width: 1400px)" srcset="{desktop}" /> -->
    <!-- <source media="(min-width: 768px)" srcset="{tablet}" />
    <source media="(min-width: 400px)" srcset="{tabletportrait}" /> -->
    <source srcset="{mobile}" />
    <img src="{mobile}" alt="{alt}" />
</picture>

<style lang="less">
    @import "../css/base.less";
</style>
